import React, { createContext, useContext, ReactNode, useEffect, useState } from 'react'

interface Props {
    children: ReactNode
}

const IsMobileContext = createContext<boolean>(false)
const IsMobileLandscapeContext = createContext<boolean>(false)
const IsTabletContext = createContext<boolean>(false)
const isMobileDevice = /iPhone|iPod|iPad|Android/i.test(navigator.userAgent);
const isTabletDevice = /iPad/i.test(navigator.userAgent);
export const ContextProvider: React.FC<Props> = ({ children }) => {
    const [isMobileLandscapeState, setIsMobileLandscapeState] = useState<boolean>(screen.orientation.type.includes('landscape'))

    useEffect(() => {
        const handleOrientationChange = ():void => {
            const isCurrentlyLandscape = screen.orientation.type.includes('landscape')
            setIsMobileLandscapeState(isCurrentlyLandscape)
        }
        handleOrientationChange()
        screen.orientation.addEventListener('change', handleOrientationChange)

        return ():void => {
            screen.orientation.removeEventListener('change', handleOrientationChange)
        }
    }, [])

    return (
            <IsTabletContext.Provider value={isTabletDevice}>
                <IsMobileContext.Provider value={isMobileDevice}>
                    <IsMobileLandscapeContext.Provider value={isMobileLandscapeState}>
                        {children}
                    </IsMobileLandscapeContext.Provider>
                </IsMobileContext.Provider>
            </IsTabletContext.Provider>
    )
}

export { IsMobileContext, IsTabletContext, IsMobileLandscapeContext }

export const useMobileContext = ():boolean => {
    const context = useContext(IsMobileContext)
    if (context === undefined) {
        throw new Error('no context found')
    }
    return context
}

export const useMobileLandscape = ():boolean => {
    const context = useContext(IsMobileLandscapeContext)
    if (context === undefined) {
        throw new Error('no context found')
    }
    return context
}


export const useTabletContext = (): boolean => {
    const context = useContext(IsTabletContext)
    if (context === undefined) {
        throw new Error('no context found')
    }
    return context
}
